import React from 'react';
import { Link } from 'react-router-dom';
import styles from './AppPage.module.css';
import compyzIcon from '../assets/compyz-icon.png';

function CompyzPage() {
  return (
    <div className={styles.appPage}>
      <div className={styles.appHero}>
        <div className={styles.heroContent}>
          <img src={compyzIcon} alt="Compyz" className={styles.appIconImg} />
          <h1>Compyz</h1>
          <span className={styles.status}>READY TO LAUNCH</span>
          <p className={styles.tagline}>
            Instant AI-powered price estimates for collectible cards when seconds matter.
          </p>
        </div>
      </div>

      <section className={styles.section}>
        <h2>The Problem</h2>
        <p>
          You're in a live online auction. A card flashes on screen. You have seconds to decide
          if the price is right. Traditional pricing apps are too slow—multiple searches,
          cross-referencing databases, waiting for results. By the time you have an answer,
          the lot is sold.
        </p>
      </section>

      <section className={styles.section}>
        <h2>The Solution</h2>
        <p>
          Compyz does one thing, and does it fast: gets you a price estimate in seconds.
          Take a screenshot, and our AI analyzes the card instantly—even with background
          noise, bad lighting, or clutter in the image.
        </p>
      </section>

      <section className={styles.section}>
        <h2>Key Features</h2>
        <ul className={styles.featureList}>
          <li>
            <strong>Screenshot Capture</strong>
            <span>Automatically analyzes your latest screenshot—no manual uploads</span>
          </li>
          <li>
            <strong>Lightning Fast</strong>
            <span>Price results in seconds, not minutes</span>
          </li>
          <li>
            <strong>Smart Recognition</strong>
            <span>Works with cards in cluttered backgrounds or poor lighting</span>
          </li>
          <li>
            <strong>No Bloat</strong>
            <span>No collection management—just fast, accurate pricing</span>
          </li>
          <li>
            <strong>Single API</strong>
            <span>No multiple API calls slowing you down</span>
          </li>
          <li>
            <strong>Auction-Ready</strong>
            <span>Built for speed, designed for competitive bidding</span>
          </li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2>Perfect For</h2>
        <div className={styles.useCards}>
          <div className={styles.useCard}>
            <h3>Live Auction Bidders</h3>
            <p>Make split-second decisions with confidence</p>
          </div>
          <div className={styles.useCard}>
            <h3>Card Shop Owners</h3>
            <p>Quick pricing for walk-in customers</p>
          </div>
          <div className={styles.useCard}>
            <h3>Collectors</h3>
            <p>Instant valuations at card shows and meetups</p>
          </div>
        </div>
      </section>

      <section className={styles.ctaSection}>
        <h2>Coming Soon</h2>
        <p>Compyz is ready to launch. Be the first to know when it's available.</p>
        <div className={styles.storeButtons}>
          <button className={styles.storeButton} disabled>
            <span className={styles.storeName}>App Store</span>
            <span className={styles.storeStatus}>Coming Soon</span>
          </button>
          <button className={styles.storeButton} disabled>
            <span className={styles.storeName}>Google Play</span>
            <span className={styles.storeStatus}>Coming Soon</span>
          </button>
        </div>
      </section>

      <div className={styles.backLink}>
        <Link to="/">← Back to Home</Link>
      </div>
    </div>
  );
}

export default CompyzPage;
